/**
 * 通联提现时间窗（每日 07:00-20:00）
 *
 * 通联侧仅在该时段内受理提现，非时段内的提交会在通联侧失败并可能留下已冻结资金，
 * 因此提现入口（主账号提现、子账号提现审批）统一用本 mixin 给出的状态做提示并置灰弹窗内操作。
 *
 * 结束时点取「不含」：20:00 起即视为超出时段，07:00 起恢复可用。
 */
export const WITHDRAW_TIME_START = 7;   // 允许提现的起始小时（含）
export const WITHDRAW_TIME_END = 20;    // 允许提现的截止小时（不含）

//判断指定时间是否处于通联允许提现的时段内，缺省取当前时间
export function isWithdrawTimeAllowed(date = new Date()) {
    const hour = date.getHours();
    return hour >= WITHDRAW_TIME_START && hour < WITHDRAW_TIME_END;
}

//弹窗内提示文案
export const WITHDRAW_TIME_TIP = '通联提现受理时间为每日 07:00-20:00，当前不在该时段内，请于 07:00 后再操作';

export default {
    data() {
        return {
            withdraw_time_allowed: isWithdrawTimeAllowed(),
            withdraw_time_timer: null,
            withdraw_time_tip: WITHDRAW_TIME_TIP
        };
    },

    computed: {
        //非可提现时段：弹窗内所有业务控件与提交按钮置灰不可操作
        withdraw_time_disabled() {
            return !this.withdraw_time_allowed;
        }
    },

    mounted() {
        //弹窗可能长时间停留，每分钟校准一次，跨入/跨出时段时自动切换可用状态
        this.withdraw_time_timer = setInterval(() => {
            this.withdraw_time_allowed = isWithdrawTimeAllowed();
        }, 60 * 1000);
    },

    beforeDestroy() {
        clearInterval(this.withdraw_time_timer);
        this.withdraw_time_timer = null;
    }
};
